import styled, { css } from 'styled-components';
import { space } from 'styled-system';

const CheckboxInputStyles = styled.input`
  display: none;
`;

const CheckboxStyles = styled.label`
  ${space}

  cursor: pointer;
  position: relative;
  padding-left: 1.875rem;

  &::before,
  &::after {
    border-radius: 0.3125rem;
    transition: none;
    position: absolute;
    width: 1.375rem;
    height: 1.375rem;
    content: '';
    display: block;
    left: 0;
    top: 0;
  }

  &::before {
    border: 0.0625rem solid ${props => props.theme.colors.checkboxBorder};
  }

  ${props =>
    props.checked === true &&
    css`
      &:after {
        background: ${props.theme.colors.primary}
          url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='8' viewBox='0 0 11 8'%3E%3Cpath fill='%23FFF' d='M15.293,7.293 L10,12.586 L7.707,10.293 C7.31462111,9.91402779 6.69091522,9.91944763 6.30518142,10.3051814 C5.91944763,10.6909152 5.91402779,11.3146211 6.293,11.707 L9.293,14.707 C9.68349985,15.0973819 10.3165001,15.0973819 10.707,14.707 L16.707,8.707 C17.0859722,8.31462111 17.0805524,7.69091522 16.6948186,7.30518142 C16.3090848,6.91944763 15.6853789,6.91402779 15.293,7.293 Z' transform='translate(-6 -7)'/%3E%3C/svg%3E")
          center center no-repeat;
      }
    `};
`;

CheckboxStyles.InputStyles = CheckboxInputStyles;

export default CheckboxStyles;
